import React from 'react';
import PropTypes from 'prop-types';
import styles from './FieldsetHeader.scss';

function FieldsetHeader({ title }) {
  return (
    <h3 className={styles.root}>{title}</h3>
  );
}

FieldsetHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

FieldsetHeader.defaultProps = {
  title: '',
};

export default FieldsetHeader;
